import React from 'react'
import styles from './Time.module.scss'
import { TimeProps, TimeState } from './types'
import isEmpty from 'lodash/isEmpty'
import intervalToDuration from 'date-fns/intervalToDuration'
import addSeconds from 'date-fns/addSeconds'

class Time extends React.Component<TimeProps, TimeState> {

  private _ID = 'player-control-time'

  state = {
    durationHours: 0,
    durationMinutes: 0,
    durationSeconds: 0,
    elapsedHours: 0,
    elapsedMinutes: 0,
    elapsedSeconds: 0
  }

  componentDidMount () {

    this.updateDuration(this.props.duration)
    this.updateTime(this.props.currentTime)

  }

  componentDidUpdate (prevProps) {

    if (this.props.duration > 0 && this.props.duration !== prevProps.duration) {

      this.updateDuration(this.props.duration)

    }

    if (this.props.currentTime > 0 && this.props.currentTime !== prevProps.currentTime) {

      this.updateTime(this.props.currentTime)

    }

  }

  splitDuration = (duration: number): { hours: number, minutes: number, seconds: number } => {

    const now = new Date(0)
    const { hours = 0, minutes = 0, seconds = 0 } = intervalToDuration({
      start: now,
      end: addSeconds(now, duration)
    })

    return {
      hours,
      minutes,
      seconds
    }

  }

  updateDuration = (duration: number) => {

    const { hours, minutes, seconds } = this.splitDuration(duration)
    this.setState({ durationHours: hours, durationMinutes: minutes, durationSeconds: seconds })

  }

  updateTime = (currentTime: number) => {

    const { hours, minutes, seconds } = this.splitDuration(currentTime)

    let update

    /** only update states that have changed. */
    if (this.state.elapsedHours !== hours) update = { elapsedHours: hours }
    if (this.state.elapsedMinutes !== minutes) update = { ...update, elapsedMinutes: minutes }
    if (this.state.elapsedSeconds !== seconds && seconds < 60) update = { ...update, elapsedSeconds: seconds }

    if (!isEmpty(update)) this.setState(update)

  }

  pad (number: number): string {

    return number.toString().padStart(2, '0')

  }
  get elapsedHours () {

    return this.pad(this.state.elapsedHours)

  }
  get elapsedMinutes () {

    return this.pad(this.state.elapsedMinutes)

  }
  get elapsedSeconds () {

    return this.pad(this.state.elapsedSeconds)

  }
  get durationHours () {

    return this.pad(this.state.durationHours)

  }
  get durationMinutes () {

    return this.pad(this.state.durationMinutes)

  }
  get durationSeconds () {

    return this.pad(this.state.durationSeconds)

  }

  render () {

    return <div className={styles['Time']} data-bdd={`${this._ID}-duration`}>
      {
        this.state.durationHours > 0 &&
        <>
          <span data-bdd={`${this._ID}-elapsed-hours`} >
            {this.elapsedHours}
          </span>
          :
        </>
      }
      <span data-bdd={`${this._ID}-elapsed-mins`} >
        {this.elapsedMinutes}
      </span>
      :
      <span data-bdd={`${this._ID}-elapsed-secs`}>
        {this.elapsedSeconds}
      </span>
      &nbsp;&frasl;&nbsp;
      {
        this.state.durationHours > 0 &&
        <>
          <span data-bdd={`${this._ID}-duration-hours`} >
            {this.durationHours}
          </span>
          :
        </>
      }
      <span data-bdd={`${this._ID}-duration-mins`} >
        {this.durationMinutes}
      </span>
      :
      <span data-bdd={`${this._ID}-duration-secs`} >
        {this.durationSeconds}
      </span>
    </div>

  }

}

export default Time
